module.exports = __webpack_public_path__ + "static/media/p-logo-breeze.e69d414d.svg";